<template>
  <div class="bgpop">
    <div :class="n_imgClass">
      <img :src="bgImgList[realData.index]" style="width: 100%; object-fit: contain" />
      <img
        :src="realData.img"
        style="margin-left: -82%; width: 50%; object-fit: contain"
      />
    </div>
    <div :class="h_imgClass">
      <div class="popTitle">能量Kcal</div>
      <div class="popText">{{realData.quantityHeat}}</div>
      <div
        style="text-align: left"
        v-for="(item, index) in popMessageList"
        :key="index"
        :id="'push' + index"
      >
        <img :src="popImgList[item.type]" style="width: 82px" />
        <div class="popValue">{{ item.value }}</div>
        <div style='margin-top:5px;'></div>
      </div>
    </div>
    <div :class="contentClass">
      <div class="title">{{ realData.goodsName }}</div>
      <!-- <div class="title">{{ "HK$ 38" + realData.price }}</div> -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";

export default {
  name: "App",
  components: {},
  props: {
    start: Boolean,
    data: Object,
  },
  setup(props) {
    watch(
      () => props.start,
      (newProps) => {
        if (newProps == true) {
          changeAnimes();
        } else {
          n_imgClass.value = "start_imgClass";
          h_imgClass.value = "dispop";
          contentClass.value = "start_content";
        }
      },
      () => props.data,
      (newProps) => {
        realData.value = newProps;
      }
    );
    const bgImgList = ref({
      1: require("../../assets/bg_greens.png"),
      0: require("../../assets/bg_protein.png"),
      2: require("../../assets/bg_staplefood.png"),
    });
    const popImgList = ref({
      1: require("../../assets/title_carbohydrate.png"),
      2: require("../../assets/title_diataryfiber.png"),
      3: require("../../assets/title_fats.png"),
      4: require("../../assets/title_proteins.png"),
    });
    const popMessageList = ref();
    onMounted(() => {
      realData.value = props.data;

      popMessageList.value = (realData.value.index == 1) ? [
      { type: "4", value: "119g" },
      { type: "1", value: "8.7g" },
      { type: "3", value: "3.9g" },
    ] : [
      { type: "4", value: "119g" },
      { type: "1", value: "8.7g" },
      { type: "2", value: "66.5g" },
    ]

    });

    const n_imgClass = ref("start_imgClass");
    const h_imgClass = ref("dispop");
    const contentClass = ref("start_content");
    const realData = ref({});

    const startAnime = ref(false);
    const changeAnimes = () => {
      setTimeout(() => {
        n_imgClass.value = "imgClass";
      }, 300 * realData.value.index);
      setTimeout(() => {
        contentClass.value = "content";
      }, 500);
      setTimeout(() => {
        h_imgClass.value = "pop";
      }, 2000);
    };
    return {
      h_imgClass,
      n_imgClass,
      contentClass,
      startAnime,
      changeAnimes,
      popMessageList,
      bgImgList,
      popImgList,
      realData,
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes foodAnime {
  from {
    transform: translate(0px, -80px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.imgClass {
  width: 100%;
  display: flex;
  margin-left: 5%;
  opacity: 1;
  animation-name: foodAnime;
  animation-duration: 1.5s;
}

.normal_imgClass {
  margin-left: 5%;
  width: 100%;
  display: flex;
  opacity: 1;
}
.start_imgClass {
  width: 100%;
  margin-left: 5%;
  display: flex;
  opacity: 0;
}

@keyframes hoverAnime {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bgpop:hover .pop {
  opacity: 1;
  animation-name: hoverAnime;
  animation-duration: 2s;
}

@keyframes push0Anime {
  0% {
    transform: translate(calc(-100%), 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.bgpop:hover #push0 {
  opacity: 1;
  animation-name: push0Anime;
  animation-duration: 0.5s;
}

@keyframes push1Anime {
  0% {
    transform: translate(calc(-100%), 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.bgpop:hover #push1 {
  opacity: 1;
  animation-name: push1Anime;
  animation-duration: 1s;
}
@keyframes push2Anime {
  0% {
    transform: translate(calc(-100%), 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.bgpop:hover #push2 {
  opacity: 1;
  animation-name: push2Anime;
  animation-duration: 1.5s;
}
@keyframes push3Anime {
  0% {
    transform: translate(calc(-100%), 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.bgpop:hover #push3 {
  opacity: 1;
  animation-name: push3Anime;
  animation-duration: 2s;
}
.dispop {
  background: white;
  position: absolute;
  top: 0px;
  opacity: 0;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
}

.pop {
  background: white;
  position: absolute;
  top: 0px;
  opacity: 0;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
}

.popTitle {
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  text-align: left;
}
.popText {
  font-size: 25px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  text-align: left;
}
.popValue {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
}

@keyframes contentAnime {
  from {
    transform: translate(0px, 40px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.content {
  opacity: 1;
  width:100%;
  margin-top:20px;
  animation-name: contentAnime;
  animation-duration: 1.5s;
}
.start_content {
  margin-top:20px;
  width:100%;
  opacity: 0;
}

.title {
  font-size: 25px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
</style>
